module.exports = __webpack_public_path__ + "static/media/roboto-v18-latin-ext_latin-300.d687dd23.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/roboto-v18-latin-ext_latin-300.woff
// module id = ./src/common/fonts/roboto-v18-latin-ext_latin-300.woff
// module chunks = 1